<template>
    <div style="background-color: #6c6c6c">
        <div v-if="step === 1" class="login-page">
            <div style="width: 100%;text-align: left;box-sizing: border-box;padding: 120px 25px 0;">
                <div style="display: flex;align-items: center">
                    <!--                <img src="../assets/logo.png" style="width: 40px;height: 40px;">-->
                    <span style="font-size: 28px;font-weight: bold;">斗罗大陆</span>
                    <span style="margin-left: 15px;">{{server}}</span>
                </div>
                <div style="font-size: 16px;color: #666666; text-align: left;margin-top: 8px;">
                    <span>欢迎登录</span>
                </div>
            </div>

            <div class="main-border">

                <van-form @submit="onSubmit" ref="submitForm">

                    <span class="ds-label" style="margin-top: 20px;">账号</span>
                    <van-field label-width="0" label="" style="color: #F18F25" :placeholder="`请输入账号`"
                               class="border-input" v-model="account" clearable>
                        <template #button>
                            <van-icon name="arrow-down" @click="selectOtherAccount"/>
                        </template>
                    </van-field>

                    <span class="ds-label" style="margin-top: 20px;">密码</span>
                    <van-field label-width="0" type="password" label="" style="color: #F18F25;"
                               placeholder="请输入登录密码" class="border-input" v-model="password" clearable/>

                    <van-popup v-model="showPicker" round position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="accountColumns"
                            @cancel="showPicker = false"
                            @confirm="pickAccount"
                            @change="onChange"
                        />
                    </van-popup>

                    <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;font-size: 14px;padding: 0 5px;">

                        <van-checkbox v-model="rememberPassword" icon-size="14px" shape="square" checked-color="#254c7e">
                            <span style="color: #666666;">记住密码</span>
                        </van-checkbox>

                    </div>

                    <div class="box-button">
                        <van-button type="info" block round native-type="submit" :loading="loading" style="height: 40px;margin-top: 50px;font-size: 16px;"
                                    loading-text="登录中"
                                    color="#254c7e">
                            登 录
                        </van-button>
                    </div>

                </van-form>
            </div>


        </div>

        <div v-if="step === 2" class="game-page">
            <iframe  allowfullscreen ref="gameIframe" :src="gameUrl" frameborder="0" scrolling="no"
                    width="100%" height="100%">
            </iframe>
        </div>

    </div>

</template>

<script>

    import {request} from '@/api/request'
    import crypto from '@/utils/crypto.js';

    import {Toast} from 'vant'

    export default {
        name: 'DldlLogin',
        data() {
            return {
                step: 1,
                account: '',
                password: '',
                rememberPassword: false,
                accountPattern: /^[a-zA-Z0-9_]{6,12}$/,
                passwordPattern: /^[a-zA-Z0-9~!@#$%^&*()_+.]{6,20}$/,
                loading: false,
                channelId: '',
                gameId: '',
                accountColumns: [],
                showPicker: false,
                userList: [],
                gameUrl: '',
                server: '',
                serverParam: '',
            };
        },
        mounted() {
            this.initPage();
        },
        methods: {
            initPage(){
                let serverParam = this.$route.path.split('/')[2];
                console.log(serverParam);

                if (serverParam === 'dldl') {
                    this.server = '灵眸黄金服';
                }
                else if (serverParam === 'lmqcf') {
                    this.server = '灵眸青春服';
                }
                else if (serverParam === 'juesqcf') {
                    this.server = '绝世青春服';
                }
                else if (serverParam === 'jsqcf') {
                    this.server = '极速青春服';
                }
                else if (serverParam === 'lhqcf') {
                    this.server = '龙皇青春服';
                }
                else if (serverParam === 'xddpt') {
                    this.server = '猎魂黄金服';
                }
                else if (serverParam === 'sldldl') {
                    this.server = '圣灵黄金服';
                }
                else {
                    this.server = '游戏平台有误';
                }
                this.serverParam = serverParam;

                let isRemember = localStorage.getItem('rememberPassword');
                if (isRemember === "true") {
                    this.rememberPassword = true;
                    this.account = localStorage.getItem('username');
                    this.password = crypto.decrypt(localStorage.getItem('password'));
                }
            },
            onSubmit() {
                let ok = this.checkForm();
                if (ok !== 'ok') {
                    Toast(ok);
                    return;
                }

                this.loading = true;
                let options = {
                    url:"/baota/login",
                    data: {
                        userName: this.account,
                        password: crypto.encrypt(this.password),
                        server: this.serverParam,
                    }
                };
                request(options).then(res => {
                    this.loading = false;
                    if (res.data.success) {
                        this.handlerRememberPassword();
                        Toast('登录成功');
                        //console.log(res.data.data)
                        this.gameUrl = res.data.data;
                        this.step = 2;
                    } else {
                        Toast.fail(res.data.error.message);
                    }
                });
            },
            checkForm() {
                let ok = 'ok';
                if (!this.account) {
                    ok = "请输入账号"
                } else if (!this.password) {
                    ok = "请输入密码";
                } else if (!this.accountPattern.test(this.account)) {
                    ok = "账号为6-12位数字或字母";
                } else if (!this.passwordPattern.test(this.password)) {
                    ok = "密码为6-20位数字字母特殊符号";
                }
                return ok;
            },
            selectOtherAccount() {
                if (this.accountColumns.length > 0) {
                    this.showPicker = true;
                } else {
                    Toast('当前没有其他账号');
                }

            },
            pickAccount() {
                this.showPicker = false;
                let user = this.userList[this.currentIndex];
                this.account = user.u;
                this.password = crypto.decrypt(user.p);
            },
            onChange(picker, value, index) {
                this.currentIndex = index;
            },
            handlerRememberPassword() {
                localStorage.setItem('rememberPassword', this.rememberPassword);

                this.userList = JSON.parse(localStorage.getItem('userList')) || [];
                let has = false;
                let index = -1;
                this.userList.forEach((v, i) => {
                    if (v.u === this.account) {
                        has = true;
                        index = i;
                    }
                })

                let password = crypto.encrypt(this.password);
                localStorage.setItem('username', this.account);
                localStorage.setItem('password', password);

                if (this.rememberPassword) {
                    if (!has) {
                        let item = {
                            u: this.account,
                            p: password,
                        }
                        this.userList.push(item);
                        localStorage.setItem('userList', JSON.stringify(this.userList));
                    }
                } else {
                    if (has) {
                        this.userList.splice(index, 1);
                        localStorage.setItem('userList', JSON.stringify(this.userList));
                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .login-page {
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        height: 100vh;
        overflow: hidden;
        background-color: #eff7fd;
    }
    .game-page {
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        height: 100vh;
        overflow: hidden;
    }
    .main-border {
        max-width: 500px;
        text-align: center;
        background-color: white;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        width: 100%;
        height: 100%;
        border: 1px solid #eceaea;
        padding: 20px 30px;
        box-sizing: border-box;
        margin-top: 30px;
    }

    .select-other {
        margin-top: 10px;
        display: block;
        font-size: 14px;
        color: #b3b3b6;
    }

    .width-line {
        height: 1px;
        margin: 0 1.04rem;
        border-bottom: 1px solid #b3b3b6;
    }

    .forget-row {
        margin-top: 1.5rem;
        font-size: .8rem;
    }

    .box-button {
        margin: 20px 3px 0;

    }

    .ds-label {
        display: inline-block;
        width: 100%;
        text-align: left;
        margin: 5px 4px 0;
        font-size: 15px;
    }

    .text-button {
        font-size: 14px;
        margin-top: 20px;
        color: #254c7e;
        text-align: center;
    }

    .van-cell{
        padding: 8px 4px;
    }
    .van-field {
        border-bottom: 1px solid #dddddd;
    }

</style>
